<template>
  <div>
    <cbs-html-sandbox
      v-if="page"
      ref="sandbox"
      :key="frameKey"
      :page="page"
      :context="sandboxContext"
      :min-height="minHeight"
      :max-height="maxHeight"
      @action="onAction"
    />
    <div
      v-else-if="loadError"
      class="text-muted small p-1"
    >{{ loadError }}</div>
    <div
      v-else
      class="d-flex justify-content-center p-2"
    >
      <b-spinner small />
    </div>
    <cbs-debug
      v-if="false"
      :context="this"
    />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import CbsHtmlSandbox from '@/cubus/components/html-sandbox/CbsHtmlSandbox.vue'
import { loadHtmlPage } from '@/cubus/html-sandbox/htmlPageApi'
// Единственный сигнал «обновиться» на дэшборде: его шлёт любой виджет, сохранивший данные
import { HBT_REFRESH } from '@/cubus/components/dashboard/habits/habitsCore'

export default {
  name: 'CbsWidgetHtml',
  components: {
    CbsHtmlSandbox,
    CbsDebug,
    BSpinner,
  },
  props: {
    widget: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      page: null,
      loadError: null,
      // смена ключа = пересоздание iframe (см. reload)
      frameKey: 0,
    }
  },
  computed: {
    pageSid() {
      const p = this.widget && this.widget.param ? this.widget.param.htmlpage : null
      if (!p) return null
      return typeof p === 'object' ? p.sid : String(p)
    },
    minHeight() {
      return Number(this.widget && this.widget.param && this.widget.param.minheight) || 120
    },
    maxHeight() {
      return Number(this.widget && this.widget.param && this.widget.param.maxheight) || null
    },
    sandboxContext() {
      return {
        mode: 'widget',
        widget: {
          id: this.widget ? this.widget.id : null,
          param: this.widget ? this.widget.param : null,
          filters: null,
        },
      }
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.$root.$on(HBT_REFRESH, this.reload)
  },
  beforeDestroy() {
    this.$root.$off(HBT_REFRESH, this.reload)
  },
  methods: {
    init() {
      if (!this.pageSid) {
        this.loadError = 'Параметр htmlpage не задан в настройках виджета.'
        return
      }
      loadHtmlPage(this.pageSid)
        .then(page => { this.page = page })
        .catch(err => { this.loadError = err.message || String(err) })
    },
    // PROP-050: HTML инжектился в sandbox-iframe один раз при монтировании, поэтому правка
    // страницы подхватывалась только полным F5 вкладки — при итеративной разработке это
    // постоянное «а почему мой фикс не применился» (13 итераций за сессию, каждая с F5).
    // Теперь на refresh страница перечитывается и сравнивается: изменился html — пересоздаём
    // фрейм (иначе новый srcdoc некуда применить), не изменился — не дёргаем DOM зря, а лишь
    // просим страницу перезапросить данные. Ошибку перезагрузки не показываем вместо рабочей
    // страницы: остаётся та, что уже отрисована.
    reload() {
      if (!this.pageSid) return
      loadHtmlPage(this.pageSid)
        .then(page => {
          const changed = !this.page || this.page.html !== page.html
          this.page = page
          if (changed) this.frameKey += 1
          else if (this.$refs.sandbox) this.$refs.sandbox.refresh()
        })
        .catch(err => {
          console.error(`[CbsWidgetHtml] reload of "${this.pageSid}" failed:`, err)
        })
    },
    onAction(name, data) {
      this.$emit('action', name, data)
    },
  },
}
</script>

<style scoped>

</style>
